import { Text } from 'blaze-ui/Text/Text'
import Styles from './MobileScheduledPostTargetPreviewItem.module.scss'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { getPlatformDisplayName } from 'utils/platformDisplayNames'
import { ScheduledPostTarget } from 'api/clients/ScheduledPostTargetsClient'
import { ValidationResult } from '../ScheduledPostTargetPreviewItem'
import { IconWithStatus } from '../IconWithStatus/IconWithStatus'
import { useMemo } from 'react'
import cx from 'classnames'
import { makePossessiveSingular } from 'utils'

type Props = {
  getActionElement: () => React.ReactNode
  needsReauth: boolean
  platform: ExternalIntegrationEnum
  providerIcon: React.ReactNode
  target?: ScheduledPostTarget
  validation: ValidationResult
}

export const MobileScheduledPostTargetPreviewItem = (props: Props) => {
  const { getActionElement, providerIcon, platform, target, validation, needsReauth } = props
  const platformDisplayName = getPlatformDisplayName(platform)

  const validationError = useMemo<string | undefined>(() => {
    const reauthError = `${makePossessiveSingular(platformDisplayName)} integration is not active.`
    const mainError = validation.errors[0]
    return needsReauth ? reauthError : mainError
  }, [validation, needsReauth, platformDisplayName])

  return (
    <div
      className={cx(Styles.itemRow, {
        [Styles.error]: needsReauth,
        [Styles.warning]: !!validationError && !needsReauth,
      })}
    >
      <div className={Styles.content}>
        <div className={Styles.iconContainer}>
          <IconWithStatus
            providerIcon={providerIcon}
            target={target}
            validation={validation}
            needsReauth={needsReauth}
          />
          <Text variant="label" fontWeight="400" color="var(--dark-90)">
            {platformDisplayName}
          </Text>
        </div>
        <div className={Styles.actionElementContainer}>{getActionElement()}</div>
      </div>
      {validationError ? (
        <div className={Styles.validationErrorMessage}>
          <Text variant="metadata">{validationError}</Text>
        </div>
      ) : null}
    </div>
  )
}
